import Velocity from 'velocity-animate'

/**
 * for transition
 */
export const leave = {
  methods: {
    leave(el, complete) {
      Velocity(el, 'slideUp', { duration: 700, complete })
    },
  },
}

/**
 * for transition
 */
export const enter = {
  methods: {
    enter(el, complete) {
      Velocity(el, 'slideDown', { duration: 700, complete })
    },
  },
}

/**
 *
 */
export const cssClassModifier = {
  methods: {
    cssClassModifier(classBlock, modifiers) {
      const classModifiers = []
      if (typeof modifiers === 'string' && modifiers) {
        modifiers = [modifiers]
      }
      if (modifiers.length) {
        modifiers.map(item => classModifiers.push(`${classBlock}--${item}`))
      }
      return classModifiers
    },
  },
}
